<template>
  <GenericTaskCreationStep
    class="advanced-options-dialog"
    v-on="$listeners"
    v-bind="$props"
  >
    <template v-slot:title>
      <!-- Overridable title -->
      <slot name="title">Advanced Options</slot>
    </template>
    <template>
      <v-tabs centered fixed-tabs v-model="currentTab">
        <v-tab v-for="tab in tabs" :key="tab">
          {{ tab }}
        </v-tab>
      </v-tabs>

      <div class="advanced-options-list">
        <v-row
          class="align-baseline"
          dense
          v-for="(option, i) in options[curOptionsGroup]"
          :key="i"
        >
          <v-col md="5">
            <b>{{ option.label }}</b>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="ml-1"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span class="advanced-option-description">
                {{ option.description }}
              </span>
            </v-tooltip>
          </v-col>
          <v-col>
            <template v-if="option.group">
              <div class="d-flex">
                <component
                  v-for="(field, i) in option.fields"
                  :class="
                    classname(
                      'advanced-option-input',
                      'group',
                      {
                        changed: optionValueChanged(field)
                      },
                      (field.props && field.props.class) || ''
                    )
                  "
                  :key="i"
                  v-bind:is="field.component"
                  v-bind="field.props"
                  :label="getConfigComponentLabel(field)"
                  :value="taskOptions[field.key]"
                  @change="
                    (value) => $emit('taskOptionsChange', field.key, value)
                  "
                  hide-details
                  dense
                  outlined
                ></component>
              </div>
            </template>
            <component
              v-else
              :class="
                classname(
                  'advanced-option-input',
                  {
                    changed: optionValueChanged(option)
                  },
                  (option.props && option.props.class) || ''
                )
              "
              v-bind:is="option.component"
              v-bind="option.props"
              v-model="taskOptions[option.key]"
              :label="getConfigComponentLabel(option)"
              :value="taskOptions[option.key]"
              @change="(value) => $emit('taskOptionsChange', option.key, value)"
              hide-details
              dense
              outlined
            ></component>
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-slot:actions>
      <!-- Overridable Actions -->
      <slot name="actions">
        <v-btn @click="$emit('backAction')">Done</v-btn>
      </slot>
    </template>
  </GenericTaskCreationStep>
</template>

<style>
.advanced-options-dialog {
  width: 800px;
}

.advanced-options-list {
  height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 16px 0;
}

.advanced-option-description {
  display: block;
  max-width: 400px;
  white-space: break-spaces;
}

.advanced-option-input {
  &.group {
    margin-right: 4px;
  }

  &.changed {
    font-weight: 800;

    &.v-text-field--outlined {
      fieldset {
        border-width: 2px;
      }
    }
  }
}
</style>

<script>
import GenericTaskCreationStep from './GenericTaskCreationStep.vue';

import _ from 'lodash';
import {
  ADVANCED_OPTIONS_GROUPS,
  advancedOptions,
  commonOptions,
  orderedOptionsTabs,
  systemOptions
} from '../constants/advancedTaskOptions';
import { defaultTaskOptions } from '@/constants/task';
import classNames from 'classnames';

export default {
  components: { GenericTaskCreationStep },
  props: {
    taskOptions: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    curOptionsGroup() {
      return this.tabs[this.currentTab];
    }
  },
  data() {
    return {
      tabs: orderedOptionsTabs,
      currentTab: 0,
      options: {
        [ADVANCED_OPTIONS_GROUPS.COMMON]: commonOptions,
        [ADVANCED_OPTIONS_GROUPS.GENERAL]: advancedOptions,
        [ADVANCED_OPTIONS_GROUPS.SYSTEM]: systemOptions
      }
    };
  },
  methods: {
    getConfigComponentLabel(option) {
      return option.component.extendOptions.name === 'v-switch'
        ? this.taskOptions[option.key]?.toString() || ''
        : option.label;
    },
    optionValueChanged(option) {
      return !_.isEqual(
        this.taskOptions[option.key],
        defaultTaskOptions[option.key]
      );
    },
    classname(...args) {
      return classNames(args);
    }
  }
};
</script>
